<template>
  <div>
    <a
      href="http://www.vigilacontigo.com/manuales/manual_informes.pdf"
      target="_blank"
      class="float-right"
      title="Ver Manual"
      ><img
        src="http://www.vigilacontigo.com/manuales/pdf.png"
        style="width: 32px; margin-left: -35px"
    /></a>
    <b-tabs content-class="mt-3" align="center">
      <b-tab :title="item.tab" v-for="item in items" :key="item.tab">
        <component :is="item.component" :ref="item.component" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import vigilacontigo from "./vigilacontigo/index";
import sivigila from "./sivigila/index";
import vigilacontigo_eventos from "./vigilacontigo_eventos/index";

export default {
  name: "listado_usuarios",
  components: {
    sivigila,
    vigilacontigo,
    vigilacontigo_eventos,
  },
  data: () => ({
    tab: null,
    items: [
      { tab: "VIGILACONTIGO", component: "vigilacontigo" },
      { tab: "SIVIGILA", component: "sivigila" },
      { tab: "EVENTOS", component: "vigilacontigo_eventos" },
    ],
  }),
};
</script>
